export enum RedirectToTypeEnum {
  Link = 'link',
  SocialLink = 'social_link',
  vCard = 'vcard',
}
